import { DateAttributeGranularity, DateGranularity } from '@gooddata/sdk-model';
import { DatePeriod } from '../../common/components/ReportingDateRangePicker';
import { RelativeDatePeriod } from '../../common/types';

type GoodDataPeriod = [DateAttributeGranularity, number, number];

export const RelativePeriods: Record<RelativeDatePeriod, GoodDataPeriod> = {
    [DatePeriod.Today]: [DateGranularity.date, 0, 0],
    [DatePeriod.Yesterday]: [DateGranularity.date, -1, -1],
    [DatePeriod.Tomorrow]: [DateGranularity.date, 1, 1],
    [DatePeriod.ThisWeek]: [DateGranularity.week, 0, 0],
    [DatePeriod.LastWeek]: [DateGranularity.week, -1, -1],
    [DatePeriod.NextWeek]: [DateGranularity.week, 1, 1],
    [DatePeriod.ThisMonth]: [DateGranularity.month, 0, 0],
    [DatePeriod.LastMonth]: [DateGranularity.month, -1, -1],
    [DatePeriod.NextMonth]: [DateGranularity.month, 1, 1],
    [DatePeriod.ThisQuarter]: [DateGranularity.quarter, 0, 0],
    [DatePeriod.LastQuarter]: [DateGranularity.quarter, -1, -1],
    [DatePeriod.NextQuarter]: [DateGranularity.quarter, 1, 1],
    [DatePeriod.ThisYear]: [DateGranularity.year, 0, 0],
    [DatePeriod.LastYear]: [DateGranularity.year, -1, -1],
    [DatePeriod.NextYear]: [DateGranularity.year, 1, 1],
};
